<style scoped>
.product {
  padding: 0 !important;
}

.product-image-area {
  overflow: hidden;
  position: relative;
  padding: 0 !important;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px !important;
}

.new-faixa {
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 4px 8px;
}

.new-faixa div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.maior-lance {
  position: relative;
  width: 100%;
}

.maior-lance .new {
  display: flex;
  justify-content: space-between;
  align-items: right;
  flex-direction: column;
}

.maior-lance span {
  font-size: 24px !important;
  line-height: 15px;
  background: rgba(235, 226, 103, .81);
  display: block;
  border-radius: 5px;
  padding: 7px 10px 12px;
  color: #575757;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: -1px;
  width: 100% !important;
}

.maior-lance small {
  font-size: 45% !important;
  display: inline-block;
  margin-top: 4px;
}

.maior-lance strong {
  margin-right: -8px;
  margin-top: -12px;
}

.product-details-area {
  padding: 4px !important;
  margin: 0px !important;
}

.product-name {
  margin: 2px !important;
}

h2.product-name {
  max-height: 35px;
  min-height: 35px;
  overflow: auto;
}

.product-ratings {
  margin: 0 0 4px 0 !important;
}

.faixa_avaliacao {
  background: #0f4261;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: #FFF;
  padding: 4px;
  border-radius: 4px;
}

.product-info {
  padding: 10px 0 0 0 !important;
  border: none;
  background: transparent;
}

.container_lance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container_lance span {
  font-size: 13px;
  font-weight: 500;
}

.container_lance button span {
  font-size: 22px;
  font-weight: 600;
}

.container_lance button {
  width: 80%;
  border-radius: 6px;
  border: 0;
  padding: 8px 0px 6px 0px;
  cursor: no-drop;
  color: #333 !important;
  background: #f7f7f7;
}

.container_lance .active {
  background: darkgreen !important;
  color: #FFF !important;
  cursor: pointer;
}

.habilitacao {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: small;
  width: 100%;
  margin-top: -2.5rem;
  color: #3f3f3f;
  background: #e6e6e6bd;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  transition: 0.3s;
  animation: efeitoTransitionHabilitacao;
  z-index: 10;
}

.habilitacao:hover {
  transition: 0.3s;
  height: 66%;
  margin-top: -19.5rem;
  flex-direction: column;
  font-size: 18px;
}

.habilitacao img {
  margin-right: 5px;
}

.habilitacao:hover img {
  margin-right: 5px;
  width: 29px;
  margin-bottom: 10px;
}

.count-lances {
  position: absolute;
  left: 10px;
}

@keyframes efeitoTransitionHabilitacao {
  0% {
    opacity: 0.3;
  }
  50% {
    height: 33%;
    opacity: 0.6;
  }
  100% {
    height: 66%;
    opacity: 1;
  }
}
</style>
<template>
  <div class="tw-w-full">
    <div class="tw-grid tw-grid-cols-4 tw-gap-3 tw-relative">
      <div class="tw-grid tw-grid-cols-4 tw-w-full tw-absolute">
        <div class="tw-flex tw-justify-between tw-items-start tw-relative tw-z-50 tw-px-3 tw-mr-2 tw-font-poppins">
          <span class="tw-text-xs tw-font-medium tw-rounded-b-lg tw-px-2.5 tw-py-1"
                :class="getStatusColor(dados.statuslote)">{{ dados.statuslote }}</span>
          <span v-if="statusleilao_id !== 17"
                class="tw-flex tw-items-center tw-justify-center tw-text-md tw-text-center tw-font-medium tw-rounded-full tw-w-7 tw-h-7 tw-px-1 tw-mt-2 tw-bg-white">{{
              dados.nu < 10 ? '0' + dados.nu : dados.nu
            }}</span>
        </div>
      </div>
      <div class="tw-grid tw-grid-cols-4 tw-w-full tw-absolute">
        <div class="tw-flex tw-justify-between tw-items-start tw-relative tw-px-3 tw-mt-32 tw-mr-2 tw-text-white">
          <i @click="openModalShare" class="icon-share-link tw-text-xl tw-cursor-pointer tw-z-40"></i>
          <i v-if="usuarioid" class="tw-text-xl tw-cursor-pointer tw-z-40"
             :class="`${dados.is_favorito ? 'icon-heart-o' : 'icon-heart'}`" @click="addFavorito"></i>
        </div>
      </div>
      <div
        v-for="(vistoria, id) in dados.vistoria"
        :key="id"
        v-if="vistoria.usuariovistorialotexstatusliberacaoextra !== undefined"
        @click.prevent="liberacaoExtraMsg(vistoria.usuariovistorialotexstatusliberacaoextra)"
        class="tw-w-[290px] tw-flex tw-cursor-pointer tw-justify-center tw-items-center tw-absolute tw-px-2 tw-h-44 tw-rounded-l-xl tw-z-50 tw-text-white tw-bg-jrBlue-100 tw-bg-opacity-40 hover:tw-bg-opacity-70">
        <div class="tw-text-center tw-uppercase tw-font-bold tw-text-sm tw-px-5">Requer Habilitação Especial
          <p><i class="icon-lock tw-mr-2 tw-mt-2"></i></p>
        </div>
      </div>
      <div class="tw-cursor-pointer" @click="redirecionarParaDetalhes">
        <carousel :dados="dados" :visualizacao="this.$parent.visualizacao"/>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-between tw-gap-2 tw-p-2.5 tw-z-10">
        <div v-show="statusleilao_id !== 17"
             @click="redirecionarParaDetalhes"
             class="tw-font-new tw-font-bold tw-text-lg tw-uppercase tw-cursor-pointer"
             v-html="dados.nm_titulo">
        </div>
        <div class="tw-cursor-pointer" @click="redirecionarParaDetalhes">
          <span v-html="descricaoLote"
                class="tw-text-jrBlue-100 tw-text-base tw-font-light tw-font-poppins tw-leading-tight tw-uppercase"></span>
        </div>
        <countdown
          :deadline="dados.dt_fechamento"
          :statusleilao_id="statusleilao_id"
          :statuslote_id="dados.statuslote"
        />
      </div>
      <div
        class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-font-semibold tw-text-sm tw-font-new">
        <div class="tw-text-xs">
          Avaliação: R$ {{
            parseFloat(dados.vl_lanceminimo).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          }}<i class="tw-ml-2 icon-dollar"></i>
        </div>
        <div v-if="dados.vl_lance !== ''" class="tw-text-xs">
          {{ statusleilao_id !== 17 ? 'Lance atual:' : 'Desconto:' }} {{
            statusleilao_id !== 17 ? dados.vl_lance : `${dados.vl_lance.replace("R$ ", "").replace(",00", "").replace(".00", "")}%`
          }} <i class="tw-ml-2 icon-info"></i>
        </div>
        <div v-else class="tw-text-xs" v-show="statusleilao_id !== 17">
          Valor inicial: {{ dados.vl_lanceinicial }}
        </div>
      </div>
      <div class="tw-flex tw-justify-center tw-items-center tw-z-10">
        <!-- Botões de Lance Início -->
        <div v-if="statusleilao_id !== 13 && statusleilao_id !== 17" class="tw-flex tw-w-1/2"
             v-show="loading === false">
          <div v-if="dados.statuslote === 'Vendido' || [1,5,8].includes(statusleilao_id)"
               class="tw-w-full tw-flex tw-flex-col tw-gap-2">
            <button class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
                    :dataloteid="dados.lote_id"
                    :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false"
                    :disabled="true"
                    :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50' : 'tw-bg-jrGray-150 tw-cursor-not-allowed')"
                    :title="'Enviar lance'"
            >
              <template
                v-if="dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
                <div v-if="(statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8)"
                     class="tw-flex tw-flex-col">
                  <span>Enviar lance</span>
                  <span>1º leilão</span>
                </div>
                <div v-else class="tw-flex tw-flex-col">
                  <span>Lance inicial</span>
                  <span>1º leilão</span>
                </div>
              </template>
              <template v-else>
                {{
                  (statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8) ? 'Enviar lance' : 'Lance inicial'
                }}
              </template>
              <span class="tw-font-semibold">{{
                  (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
                }}</span>
            </button>
            <template
              v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
              <button
                class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
                :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                :disabled="true"
                :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrGray-150 tw-cursor-not-allowed' : 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50')"
                :title="'Enviar lance'"
              >
                <div v-if="(statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8)"
                     class="tw-flex tw-flex-col">
                  <span>Enviar lance</span>
                  <span>2° Leilão</span>
                </div>
                <div v-else class="tw-flex tw-flex-col">
                  <span>Lance inicial</span>
                  <span>2° Leilão</span>
                </div>
                <span class="tw-font-semibold">{{
                    (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
                  }}</span>
              </button>
            </template>
          </div>
          <div v-else class="tw-w-full tw-flex tw-flex-col tw-gap-2">
            <button
              class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
              @click="enviarLance"
              :dataloteid="dados.lote_id"
              :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false"
              :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao"
              :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50' : 'tw-bg-jrGray-150 tw-cursor-not-allowed')"
              :title="'Enviar lance'"
            >
              <template
                v-if="dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
                <div v-if="(statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8)"
                     class="tw-flex tw-flex-col">
                  <span>Enviar lance</span>
                  <span>1º leilão</span>
                </div>
                <div v-else class="tw-flex tw-flex-col">
                  <span>Lance inicial</span>
                  <span>1º leilão</span>
                </div>
              </template>
              <template v-else>
                {{
                  (statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8) ? 'Enviar lance' : 'Lance inicial'
                }}
              </template>
              <span class="tw-font-semibold">{{
                  (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
                }}</span>
            </button>

            <template
              v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
              <button
                class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
                @click="enviarLance"
                :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                :disabled="(!liberado || !dados.liberado)  && leilao.leilao_id_primeiroleilao"
                :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrGray-150 tw-cursor-not-allowed' : 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50')"
                :title="'Enviar lance'"
              >
                <div v-if="(statusleilao_id !== 1 && statusleilao_id !== 5 && statusleilao_id !== 8)"
                     class="tw-flex tw-flex-col">
                  <span>Enviar lance</span>
                  <span>2º leilão</span>
                </div>
                <div v-else class="tw-flex tw-flex-col">
                  <span>Lance inicial</span>
                  <span>2º leilão</span>
                </div>
                <span class="tw-font-semibold">{{
                    (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
                  }}</span>
              </button>
            </template>
          </div>
        </div>
        <div v-else-if="statusleilao_id !== 17" class="tw-flex" v-show="loading === false">
          <div v-if="dados.statuslote === 'Vendido' || [1,5,8].includes(statusleilao_id)"
               class="tw-w-full tw-flex tw-flex-col tw-gap-2">
            <button
              class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
              :dataloteid="dados.lote_id"
              :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false"
              :disabled="true"
              :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50' : 'tw-bg-jrGray-100 tw-cursor-not-allowed')"
              :title="!liberado || !dados.liberado ? 'Necessita de permissões' : 'Enviar lance'"
            >
              <template
                v-if="dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'"
                class="tw-flex tw-flex-col"
              >
                <span>Venda Direta</span>
                <span>1° Leilão</span>
              </template>
              <template v-else>
                <span>Venda Direta</span>
              </template>
              <span class="tw-font-semibold">{{
                  (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
                }}</span>
            </button>

            <template
              v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
              <button
                class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
                :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                :disabled="true"
                :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrGray-100 tw-cursor-not-allowed' : 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50')"
                :title="!liberado || !dados.liberado ? 'Necessita de permissões' : 'Enviar lance'"
              >
                <div class="tw-flex tw-flex-col">
                  <span>Venda Direta</span>
                  <span>2° Leilão</span>
                </div>
                <span class="tw-font-semibold">{{
                    (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
                  }}</span>
              </button>
            </template>
          </div>
          <div v-else class="tw-w-full tw-flex tw-flex-col tw-gap-2">
            <button
              class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
              @click="enviarVendadireta"
              :dataloteid="dados.lote_id"
              :datavalor="(!leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : false"
              :disabled="(!liberado || !dados.liberado) && leilao.leilao_id_primeiroleilao"
              :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50' : 'tw-bg-jrGray-100 tw-cursor-not-allowed')"
              :title="!liberado || !dados.liberado ? 'Necessita de permissões' : 'Enviar lance'"
            >
              <template
                v-if="dados.vistoria_vl_lanceinicialsegundoleilao != 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao != undefined && dados.vistoria_vl_lanceinicialsegundoleilao != 'R$ NaN'"
                class="tw-flex tw-flex-col"
              >
                <span>Venda Direta</span>
                <span>1° Leilão</span>
              </template>
              <template v-else>
                <span>Venda Direta</span>
              </template>
              <span class="tw-font-semibold">{{
                  (leilao.leilao_id_primeiroleilao) ? dados.primeiro_vistoria_vl_lanceinicial : dados.vl_lance_sugerido
                }}</span>
            </button>
            <template
              v-if="![4].includes(leilao.statustipoleilao_id) && leilao.dt_segundoleilao_data !== null && leilao.dt_segundoleilao_hora !== null && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ 0,00' && dados.vistoria_vl_lanceinicialsegundoleilao !== undefined && dados.vistoria_vl_lanceinicialsegundoleilao !== 'R$ NaN'">
              <button
                class="tw-flex tw-flex-col tw-items-center tw-text-white tw-px-2.5 tw-py-1 tw-rounded-md tw-text-xs"
                @click="enviarVendadireta"
                :dataloteid="dados.lote_id"
                :datavalor="(!leilao.leilao_id_primeiroleilao) ? false : dados.vl_lance_sugerido"
                :disabled="(!liberado || !dados.liberado)  && leilao.leilao_id_primeiroleilao"
                :class="(!leilao.leilao_id_primeiroleilao ? 'tw-bg-jrGray-100 tw-cursor-not-allowed' : 'tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50')"
                :title="!liberado || !dados.liberado ? 'Necessita de permissões' : 'Enviar lance'"
              >
                <span>Venda Direta</span>
                <span>2° Leilão</span>
                <span>{{
                    (leilao.leilao_id_primeiroleilao) ? dados.vl_lance_sugerido : dados.vistoria_vl_lanceinicialsegundoleilao
                  }}</span>
              </button>
            </template>
          </div>
        </div>
        <!-- Botões de Lance Fim -->
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from '@/components/shared/Countdown.vue'
import Carousel from '@/components/shared/Carousel.vue'
import Slide from '@/components/customCarousel/Slide'
import {Stretch, Circle6} from 'vue-loading-spinner'

export default {
  name: 'Lista',
  components: {
    Countdown,
    Carousel,
    Stretch,
    Circle6,
    Slide
  },

  props: [
    'countLances',
    'leilao',
    'dados',
    'liberado',
    'usuarioid',
    'statusleilao_id',
    'intermediarios',
    'paramsite_proposta',
    'time'
  ],

  data() {
    return {
      errors: [],
      loading: false,
      pathName: location.protocol + '//' + window.HOSTNAME,
      widthCarousel: 235,
      vl_avaliacaocredito: '-',
      liberacaoStatus: false,
      money: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
        min: 0,
        max: 100
      }
    }
  },
  computed: {
    descricaoLote() {

      const descricao = this.dados.nm_descricao

      if (descricao.length > 44)
        return "Acesse este lote para visualizar mais informações"

      return this.dados.nm_descricao
    }
  },
  created() {
    const self = this

    this.firebase_db.ref(
      `/vl_avaliacaocredito/${self.dados.leilao_id}/${self.dados.lote_id}`
    ).on('value', function (vl_avaliacao_data) {
      var data = vl_avaliacao_data.val()
      if (data != undefined) {
        self.vl_avaliacaocredito = data.vl_credito
      }
    });

    window.addEventListener("resize", this.checkWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkWindowResize);
  },
  methods: {
    openModalShare() {
      const dados = {
        header: 'Compartilhe este lote em suas redes',
        title: this.dados.nm_titulo,
        description: this.dados.nm_descricao,
        url: `${this.pathName}/leilao/index/leilao_id/${this.dados.leilao_id}/lote/${this.dados.lote_id}`,
      }

      this.$parent.$refs.headerDisputa.$emit('modalShared', dados)
    },

    getStatusColor(status) {
      switch ( status ) {
        case "Aberto para Lance":  return "tw-bg-white";
        case "Em Pregão":          return "tw-bg-white";
        case "Dou-lhe Duas":       return "tw-text-white tw-bg-jrBlue-200";
        case "Vendido":            return "tw-text-white tw-bg-jrGray-150";
        case "Condicional":        return "tw-text-white tw-bg-jrGray-300";
        case "Repasse":            return "tw-text-white tw-bg-jrGray-300";
        case "Não Vendido":        return "tw-bg-white";
        case "Não Homologado":     return "tw-bg-jrGray-100";
        case "Homologado":         return "tw-text-white tw-bg-jrBlue-100";
        case "Retirado":           return "tw-text-white tw-bg-jrGray-300";
        case "Repasse com Lance":  return "tw-text-white tw-bg-jrBlue-100";
        case "Dou-lhe Uma":        return "tw-bg-jrGray-100";
        case "Cancelado":          return "tw-text-white tw-bg-jrRed-100";
        case "Dou-lhe Três":       return "tw-bg-white";
        case "Excluido":           return "tw-text-white tw-bg-jrRed-100";
        case "Adiado":             return "tw-text-white tw-bg-jrRed-100";
        case "Arrematado Não pago":   return "tw-text-white tw-bg-jrBlue-new";
        case "Arrematado Sub Judice": return "tw-bg-white";
      }
    },

    checkWindowResize() {
      if (window.innerWidth < 970)
        this.$parent.visualizacao = 'card'
    },

    liberacaoExtraMsg(descricao) {
      this.$parent.modalHabilitacao(descricao)
    },

    isNumber: function (evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    addFavorito() {
      const hostName = location.protocol + '//' + window.HOSTNAME
      const self = this

      let urlRequest = this.dados.is_favorito
        ? 'exclui-favorito'
        : 'add-favorito'

      this.dados.is_favorito = !this.dados.is_favorito

      fetch(`${hostName}/leilao/${urlRequest}`, {
        params: {
          lote_id: this.dados.lote_id,
          usuario_id: this.usuarioid
        }
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(function (response) {
          self.$parent.$emit('favoritoModificado', self)
          self.$parent.$parent.$emit('favoritoModificado', self)
        })
        .catch(function (error) {
          console.log(error);
        })
    },

    enviarVendadireta(ev) {
      var is_lance = false
      const elem = ev.currentTarget

      if (
        elem.getAttribute('disabled') == true ||
        elem.getAttribute('disabled') == 'disabled'
      ) {
        // VERIFICA STATUS DE LIBERADO, CASO TRUE A FUNCAO ACABA AQUI
        return false
      }

      const nm_valor = elem.getAttribute('datavalor')
      const valor = elem
        .getAttribute('datavalor')
        .replace(/\./g, '')
        .replace('R$ ', '')
        .replace(',', '.')
      const loteId = elem.getAttribute('dataloteid')
      const self = this

      this.firebase_db.ref(`/lance/${self.dados.leilao_id}/${loteId}`)
        .orderByChild('id')
        .limitToLast(1)
        .once('value')
        .then(function (data) {
          var usuario_id_logado = self.usuarioid
          if (data.val()) {
            var usuario_id_ultimolance = Object.values(data.val())[0]
              .nm_usuario_id
          } else {
            var usuario_id_ultimolance = null
          }

          if (usuario_id_logado == usuario_id_ultimolance) {
            eventParcelamento()
            var elemParcelas = parcelamento(self)

            self.$modal.show('dialog', {
              title: `<strong style="font-size:20px;color: #512925;">Lote ${self.dados.nu}</strong>`,
              text: ` <p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                                <p>${self.dados.nm_titulo}</p>
                                ${elemParcelas}
                                <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${self.dados.vl_lance_sugerido}</strong> </p>`,
              buttons: [
                {
                  title: 'NÃO',
                  handler: () => {
                    self.loading = false
                    self.$modal.hide('dialog')
                  }
                },
                {
                  title: 'SIM',
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide('dialog')
                    var parcela = document.querySelector('#limite_parcelas option:checked').value
                    modalEnviaLance(
                      self,
                      loteId,
                      valor,
                      nm_valor,
                      is_lance,
                      'Lote',
                      null,
                      null,
                      parcela
                    )
                  }
                }
              ]
            })
          } else {
            modalEnviaLance(
              self,
              loteId,
              valor,
              nm_valor,
              is_lance,
              'Lote',
              null,
              null,
              null
            )
          }
        })
    },

    enviarLance(ev) {
      if (!this.dados.liberado || !!!this.usuarioid) {
        return false
      }

      var is_lance = true
      const elem = ev.currentTarget

      if (
        elem.getAttribute('disabled') == true ||
        elem.getAttribute('disabled') == 'disabled'
      ) {
        // VERIFICA STATUS DE LIBERADO, CASO TRUE A FUNCAO ACABA AQUI
        return false
      }

      var valor = 0
      const loteId = elem.getAttribute('dataloteid')
      var titulo = 'Lote'
      if (elem.getAttribute('datavalor') == 0) {
        valor = document.querySelector('#enviar_lance_manual_val_' + loteId)
          .value
        var nm_valor = valor + ' % de desconto'
        valor = valor
          .replace(/\./g, '')
          .replace('R$ ', '')
          .replace(',', '.')
        if (valor > 100) {
          alert('Valor maior que o permitido de 100%')
          return false
        }
        titulo = 'Rodada'
      } else {
        var nm_valor = elem.getAttribute('datavalor')
        valor = elem
          .getAttribute('datavalor')
          .replace(/\./g, '')
          .replace('R$ ', '')
          .replace(',', '.')
      }

      const self = this

      this.firebase_db.ref(`/lance/${self.dados.leilao_id}/${loteId}`)
        .orderByChild('id')
        .limitToLast(1)
        .once('value')
        .then(function (data) {
          if (data.val()) {
            // console.log(data);
            var usuario_id_ultimolance = Object.values(data.val())[0]
              .nm_usuario_id
          } else {
            var usuario_id_ultimolance = null
          }

          var nm_intermediado = null
          var usuario_id_logado = null
          var usuario_id_intermediado = null

          if (self.intermediarios != null) {
            nm_intermediado = document.querySelector(
              '#cmb_usuario_intermediario_' + loteId
            ).selectedOptions[0].text
            usuario_id_intermediado = document.querySelector(
              '#cmb_usuario_intermediario_' + loteId
            ).value
            usuario_id_logado = usuario_id_intermediado
          } else {
            usuario_id_logado = self.usuarioid
          }

          if (usuario_id_logado == usuario_id_ultimolance) {
            eventParcelamento()
            var elemParcelas = parcelamento(self)

            self.$modal.show('dialog', {
              title:
                `<strong style="font-size:20px;color: #512925;">` +
                titulo +
                ` ${self.dados.nu}</strong>`,
              text: ` <p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                                <p>${self.dados.nm_titulo}</p>
                                ${elemParcelas}
                                <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${nm_valor}</strong> </p>`,
              buttons: [
                {
                  title: 'NÃO',
                  handler: () => {
                    self.loading = false
                    self.$modal.hide('dialog')
                  }
                },
                {
                  title: 'SIM',
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide('dialog')
                    var parcela = document.querySelector('#limite_parcelas option:checked').value
                    modalEnviaLance(
                      self,
                      loteId,
                      valor,
                      nm_valor,
                      is_lance,
                      titulo,
                      usuario_id_intermediado,
                      nm_intermediado,
                      parcela
                    )
                  }
                }
              ]
            })
          } else {
            modalEnviaLance(
              self,
              loteId,
              valor,
              nm_valor,
              is_lance,
              titulo,
              usuario_id_intermediado,
              nm_intermediado,
              null
            )
          }
        })
    },

    loteClicado() {
      this.$parent.$emit('loteIdAtualChange', this.dados.lote_id)
    },

    redirecionarParaDetalhes() {
      window.location.href = `/leilao/index/leilao_id/${this.dados.leilao_id}/lote/${this.dados.lote_id}`;
    },

    formatStatusCredito(statuslote) {
      var nm_statuslote = ''
      switch (statuslote) {
        case 'Aberto para Lances':
          nm_statuslote = 'Aguarde'
          break
        case 'Vendido':
        case 'Não Vendido':
          nm_statuslote = 'Encerrado'
          // expected output: "Mangoes and papayas are $2.79 a pound."
          break
        default:
          nm_statuslote = statuslote
      }
      return nm_statuslote
    }
  }
}

function parcelamento(self) {
  var parcelamento = self.$root.refreshParcelamento(self.dados)

  var elemParcelas = `<label style="${(!self.dados.nu_limiteparcelaslote) ? 'display: none;' : ''}"> Parcelas`
  elemParcelas += `<select id="limite_parcelas" onchange="window.eventParcelas()" style="width: 119px; padding: 5px; margin-right: 6px">`
  if (self.dados.nu_limiteparcelaslote) {
    for (let index = 1; index <= parcelamento; index++) {
      var text = (index === 1) ? 'à vista' : index
      elemParcelas += `<option value="${index}" ${(index == 1) ? 'selected' : ''}>${text}</option>`
    }
  } else {
    elemParcelas += `<option value="1" selected>à vista</option>`
  }
  elemParcelas += '</select>'
  elemParcelas += `<small id="limite_parcelas_porcentagem" style="float: right; margin-top: 8px;display:none;">${self.dados.nu_limitepercentuallote} % de entrada</small>`
  elemParcelas += '</label>'
  return elemParcelas
}

function eventParcelamento() {
  window.eventParcelas = () => {
    var limite_parcelas = document.querySelector('#limite_parcelas option:checked').value
    if (limite_parcelas > '1') {
      document.querySelector('#limite_parcelas_porcentagem').style.display = 'block'
    } else {
      document.querySelector('#limite_parcelas_porcentagem').style.display = 'none'
    }
  }
}

function modalEnviaLance(
  self,
  loteId,
  valor,
  nm_valor,
  is_lance,
  titulo,
  usuario_id_intermediado,
  nm_intermediado,
  pl
) {
  var nm_descricao = '<p>Confirmar o envio de lance?</p>'

  if (is_lance == false) {
    nm_descricao = '<p>Confirmar a venda direta ?</p>'
  }

  if (usuario_id_intermediado != null) {
    nm_descricao =
      `<p>Confirmar o envio de lance para o usuário <b style="color: red;">` +
      nm_intermediado +
      ` </b>?</p>`
  }

  eventParcelamento()
  var elemParcelas = (!pl) ? parcelamento(self) : ''

  // Ja existente
  self.$modal.show('dialog', {
    title: `<strong style="font-size:20px;color: #512925;">` + titulo + ` ${self.dados.nu}</strong>`,
    text: `<p style="color: #512925;"><strong>${self.dados.nm_titulo}</strong></p>
          ${nm_descricao}
          ${(pl) ? `<p><strong style="color: #512925;">${(pl > 1) ? pl + ' parcelas' : 'à vista'}</strong></p>` : ''}
          ${elemParcelas}
          <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${nm_valor}</strong> </p>`,
    buttons: [
      {
        title: 'Cancelar',
        handler: () => {
          self.loading = false
          self.$modal.hide('dialog')
        }
      },
      {
        title: 'Enviar',
        default: true, // HABILITAR BOTÃO ENTER
        handler: () => {
          self.loading = true
          var parcelas = (!pl) ? document.querySelector('#limite_parcelas option:checked').value : pl
          var urlParcelas = (parcelas > 1) ? '&nu_parcelas=' + parcelas : '&nu_parcelas=' + 1

          var url_post = `${self.pathName}/leilao/envialance/?ajax=1&leilao_id=${self.dados.leilao_id}&lote_id=${loteId}&vl_lance=${valor}&force=0${urlParcelas}&firebase=1`
          if (usuario_id_intermediado != null) {
            url_post =
              url_post + '&usuario_id_intermediado=' + usuario_id_intermediado
          }

          fetch(url_post, {method: 'POST'})
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
              }
              return res.json();
            })
            .then(res => {
              if (res.data.erro == true) {
                self.errors.push(res)
                alert(self.$root.decodeHtml(res.data.msg_erro))
              }
              // Tracking google analytics envio de lance
              ga('send', 'event', 'lance', 'enviado')

              // FECHA MODAL E PARA O LOADING
              self.loading = false
              self.$modal.hide('dialog')
            })
            .catch(e => {
              self.errors.push(e)
              self.loading = false
              self.$modal.hide('dialog')
            })
        }
      }
    ]
  })
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Lista.vue